"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var Svg16LogoGoogle = function Svg16LogoGoogle(_ref) {
  var fill = _ref.fill,
      useDefaultColors = _ref.useDefaultColors,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["fill", "useDefaultColors", "title"]);

  return _react.default.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: useDefaultColors ? 'none' : fill,
    "aria-hidden": title === null || typeof title !== 'string' || title.length === 0
  }, props), _react.default.createElement("title", null, title), _react.default.createElement("path", {
    d: "M12 7.093c1.502 0 2.516.65 3.093 1.191l2.258-2.204C15.965 4.791 14.161 4 12.001 4a7.994 7.994 0 0 0-7.148 4.409l2.587 2.009C8.09 8.488 9.885 7.093 12 7.093z",
    fill: useDefaultColors ? '#EA4335' : fill
  }), _react.default.createElement("path", {
    d: "M19.68 12.178c0-.658-.053-1.138-.169-1.636H12v2.97h4.409c-.089.737-.569 1.848-1.636 2.595l2.525 1.955c1.51-1.395 2.382-3.449 2.382-5.884z",
    fill: useDefaultColors ? '#4285F4' : fill
  }), _react.default.createElement("path", {
    d: "M7.449 13.582A4.925 4.925 0 0 1 7.182 12c0-.551.098-1.085.258-1.582l-2.587-2.01A8.007 8.007 0 0 0 4 12c0 1.289.311 2.507.853 3.591l2.596-2.009z",
    fill: useDefaultColors ? '#FBBC05' : fill
  }), _react.default.createElement("path", {
    d: "M12 20c2.16 0 3.973-.711 5.298-1.938l-2.525-1.955c-.675.47-1.582.8-2.773.8-2.116 0-3.911-1.396-4.551-3.325l-2.587 2.01C6.178 18.203 8.872 20 12 20z",
    fill: useDefaultColors ? '#34A853' : fill
  }));
};

Svg16LogoGoogle.propTypes = {
  title: _propTypes.default.string,
  fill: _propTypes.default.string,
  useDefaultColors: _propTypes.default.bool
};
var _default = Svg16LogoGoogle;
exports.default = _default;